import {makeStyles} from '@material-ui/core/styles'

export default makeStyles({
  eventBtn: {
    marginBottom: '20px'
  }
})
